{
	"Features": {
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {},
					"value": "https://maps.app.goo.gl/QLNqhLzBXiHdT6Xv7"
				},
				"label": {
					"translations": {},
					"value": "Read Our Reviews!"
				}
			}
		},
		"bgAltBase": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "mx-auto btn btn-primary hover-ripple"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "We love hearing from our customers! Your feedback helps us grow and continue providing the best service possible. Check out what others have to say, and if you've had a great experience, we'd love for you to share your thoughts too!"
			},
			"type": "TextArea",
			"value": "---\nWe love hearing from our customers! Your feedback helps us grow and continue providing the best service possible. Check out what others have to say, and if you've had a great experience, we'd love for you to share your thoughts too!\n\n---"
		},
		"flipped": {
			"permission": "Admin",
			"translations": {
				"en-US": "true"
			},
			"type": "TextInput",
			"value": "true"
		},
		"index": 0,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "04"
		},
		"theme": {
			"permission": "Admin",
			"translations": {
				"en-US": "light"
			},
			"type": "TextInput",
			"value": "light"
		}
	},
	"PageBanner": {
		"bgImage": {
			"permission": "Admin",
			"translations": {},
			"type": "Image",
			"value": {
				"description": {
					"translations": {},
					"value": "Thank you card with a pen on a desk beside legal books and a judge’s gavel."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/tj-moore.firebasestorage.app/o/uploads%2Ftestimonials%2FPageBanner%2FbgImage%2FTestimonails%20Banner.jpg?alt=media&token=37d8e291-0fba-4d5c-8995-4b773693b90f",
				"formattedSize": "100.82 KB",
				"height": 488,
				"name": "Testimonails Banner.jpg",
				"path": "uploads/testimonials/PageBanner/bgImage/Testimonails Banner.jpg",
				"query": "?as=run",
				"size": 103241,
				"type": "image/jpeg",
				"updated": "2025-02-21T15:55:49.932Z",
				"width": 1588
			}
		},
		"bgImageDescription": {
			"permission": "Admin",
			"translations": {
				"en-US": "A wooden desk with an open notebook, a fountain pen, and a thank-you letter, symbolizing client trust. A gavel and a legal book sit nearby, representing justice and professionalism. The softly blurred background suggests a welcoming law office with warm and inviting lighting."
			},
			"type": "TextArea",
			"value": "A wooden desk with an open notebook, a fountain pen, and a thank-you letter, symbolizing client trust. A gavel and a legal book sit nearby, representing justice and professionalism. The softly blurred background suggests a welcoming law office with warm and inviting lighting."
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"bgImageClass": {
					"translations": {},
					"value": "w-full"
				},
				"contentClass": {
					"translations": {},
					"value": "bg-base-300 inline-block p-2 sm:p-4 md:p-6 xl:p-8 rounded mx-2 sm:mx-4"
				}
			}
		},
		"index": 1,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "02"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Criminal Lawyers Birmingham Office of Thomas Johnson Moore"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Testimonials"
			},
			"type": "TextInput",
			"value": "Testimonials"
		}
	},
	"Testimonials": {
		"description": {
			"permission": "Admin",
			"translations": {
				"en-US": "Real experiences from real people! We take pride in providing top-notch service, and our customers' words speak for themselves. Below, you'll find a selection of recent reviews from across the web, sharing their honest feedback about their experience with us. Your trust means everything, and if you've worked with us, we'd love to hear from you too!"
			},
			"type": "TextArea",
			"value": "---\nReal experiences from real people! We take pride in providing top-notch service, and our customers' words speak for themselves. Below, you'll find a selection of recent reviews from across the web, sharing their honest feedback about their experience with us. Your trust means everything, and if you've worked with us, we'd love to hear from you too!"
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "03"
		},
		"theme": {
			"permission": "Admin",
			"translations": {
				"en-US": "light"
			},
			"type": "TextInput",
			"value": "light"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en-US": "Testimonials"
			},
			"type": "TextInput",
			"value": "What Our Customers Say"
		}
	},
	"TestimonialsPage": {
		"index": 3
	}
}